import { Caract_proy_mod } from './../../../models/caract_proy_mod.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-caract_proy_mod",
    templateUrl: "./caract_proy_mod.component.html",
    styleUrls:['./caract_proy_mod.component.css'],
    providers: [FormService]
})

export class Caract_proy_modComponent {
    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
      public rows = [];
      public actualRow;
      public actualRow2;
      public caract_proy_mod: Caract_proy_mod;
      public form;
      public temp_carct_proy_mod;
      public matcher = new FormService();
      public nombreForm;

    constructor(private dialog: MatDialog){


        this.nombreForm = localStorage.getItem("form");
        console.log(this.nombreForm)
        this.form = new FormGroup({
            caract_proy_mod: new FormControl(''),
            lotes_proy_mod: new FormControl(''),
            mz_proy_mod: new FormControl(''),
            sup_proy_mod: new FormControl(''),
            hoja_anexa_mod: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("caract_proy_mod"))){
            localStorage.setItem("caract_proy_mod", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("caract_proy_mod"));
            
            this.form.controls['lotes_proy_mod'].setValue(this.rows[0]?this.rows[0].lotes_proy_mod:'')
            this.form.controls['mz_proy_mod'].setValue(this.rows[0]?this.rows[0].mz_proy_mod:'')
            this.form.controls['sup_proy_mod'].setValue(this.rows[0]?this.rows[0].sup_proy_mod:'')
            this.form.controls['hoja_anexa_mod'].setValue(this.rows[0]?this.rows[0].hoja_anexa_mod:'')

        }
        this.caract_proy_mod = {lotes_proy_mod:'',mz_proy_mod:'',sup_proy_mod:'',hoja_anexa_mod:''};
        this.temp_carct_proy_mod = {lotes_proy_mod:'',mz_proy_mod:'',sup_proy_mod:'',hoja_anexa_mod:''};  
    }

    add_caract_proy_mod(){
        

        this.actualRow = localStorage.getItem("caract_proy_mod");

        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            caract_proy_mod: this.form.value.caract_proy_mod,
            lotes_proy_mod: this.form.value.lotes_proy_mod,
            mz_proy_mod: this.form.value.mz_proy_mod,
            sup_proy_mod: this.form.value.sup_proy_mod,
            hoja_anexa_mod: this.form.value.hoja_anexa_mod
           
        })
        localStorage.setItem("caract_proy_mod", JSON.stringify(this.rows));
        this.actualRow2 = localStorage.getItem("caract_proy_mod");
        console.log(this.actualRow2)
      
        //this.form.reset();
    }

    get_caract_proy_mod(id){
        console.log(id)
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
               this.temp_carct_proy_mod.id = id;
               this.temp_carct_proy_mod.caract_proy_mod =  this.rows[x].caract_proy_mod;
               this.temp_carct_proy_mod.lotes_proy_mod =  this.rows[x].lotes_proy_mod;
               this.temp_carct_proy_mod.mz_proy_mod =  this.rows[x].mz_proy_mod;
               this.temp_carct_proy_mod.sup_proy_mod =  this.rows[x].sup_proy_mod;
               this.temp_carct_proy_mod.hoja_anexa_mod =  this.rows[x].hoja_anexa_mod;

               this.dialog.open(this.openModal);
            }
        }
    }

    cleanData(){
        this.temp_carct_proy_mod = {lotes_proy_mod:'',mz_proy_mod:'',sup_proy_mod:'',hoja_anexa_mod:''};
    }

    savecaract_proy_mod(){
       var  id = this.temp_carct_proy_mod.id;
        console.log(this.temp_carct_proy_mod)
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("caract_proy_mod", JSON.stringify(this.rows));
           
                    $("#clasif_modal").modal("hide");
                    this.actualRow = localStorage.getItem("caract_proy_mod");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        sup_ant_loteo: this.temp_carct_proy_mod.lotes_proy_mod,
                        num_anteproy_act: this.temp_carct_proy_mod.mz_proy_mod,
                        sup_anteproy_act: this.temp_carct_proy_mod.sup_proy_mod,
                        hoja_anexa_loteo: this.temp_carct_proy_mod.hoja_anexa_mod

                    })
                    localStorage.setItem("caract_proy_mod", JSON.stringify(this.rows));
                    this.temp_carct_proy_mod = {lotes_proy_mod:'',mz_proy_mod:'',sup_proy_mod:'',hoja_anexa_mod:''};
                    this.dialog.closeAll();
                }
            }         
    }

    delete_caract_proy_mod(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("caract_proy_mod", JSON.stringify(this.rows));
            }
        }
    }

}